import InfiniteMenu from "./InfiniteMenu";

export default function InfinitePlanetMenu({
  items = [],
  scale = 1.0,
  initialActiveItemId = null,
  onPlanetClick = null,
  onActivePlanetChange = null,
  onMovementChange = null,
}) {
  return (
    <InfiniteMenu
      items={items}
      scale={scale}
      variant="sphere"
      initialActiveItemId={initialActiveItemId}
      onItemClick={onPlanetClick}
      onActiveItemChange={onActivePlanetChange}
      onMovementChange={onMovementChange}
    />
  );
}
